import { createContext, FC, useState, useContext } from 'react';
import type { ServerInvoiceRes } from '@/types/checkout';

type ThemeData = ServerInvoiceRes['theme'] | null;

type ThemeDataStore = {
  themeData: ThemeData;
  setThemeData: (data: ThemeData) => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const ThemeDataContext = createContext<ThemeDataStore>({
  themeData: null,
  setThemeData: noop,
});

export const ThemeDataProvider: FC = ({ children }) => {
  const [themeData, setThemeData] = useState<ThemeData>(null);
  return <ThemeDataContext.Provider value={{ themeData, setThemeData }}>{children}</ThemeDataContext.Provider>;
};

export const useThemeData = (): ThemeDataStore => useContext(ThemeDataContext);
